import ReactDOM from 'react-dom'
import { useEffect, useState} from "react"
import {CloseOutlined} from '@ant-design/icons'
export const useCanvas = (components)=>{

  const [canvas,setCanvas]=useState(false)

  useEffect(()=>{
    ReactDOM.render(canvas?<EnlargeMore components={components} canvas={canvas} setCanvas={setCanvas} />:'',document.getElementById('modal'))
  },[canvas,components])

  return setCanvas
} 
function EnlargeMore(props){
  let {setCanvas,components}=props
  return(
    <div className="enlarge-img">   
        
      <div className="Exit-btn" ><CloseOutlined onClick={()=>{setCanvas(false)}}/></div>
      <div className="enlarge-box">
        {components}
      </div>
    </div>
  )
}

